import { Helmet } from 'react-helmet-async';
import { Flex } from '@chakra-ui/react';
import UploadZipForm from 'components/productManager/UploadZipForm';
import AssetManagerPage from 'components/common/AssetManagerPage';
import Layout from 'components/common/Layout';
import { Pages } from 'constants/pages';

const NewProduct = () => (
  <Layout testId="new-product-page" pages={[Pages.ProductManager]}>
    <Helmet title="New Product" />
    <AssetManagerPage title="New Product">
      <Flex flex={1} flexDir="column">
        <UploadZipForm setOverflow={() => {}} />
      </Flex>
    </AssetManagerPage>
  </Layout>
);

export default NewProduct;
